export function walletShort(wallet) {
  return wallet.substr(0, 4) + "..." + wallet.substr(wallet.length - 4);
}

export function walletShortLast(wallet) {
  return ".." + wallet.substr(wallet.length - 4);
}

export function vaultIdShort(str) {
  if (str.includes("Autofarm_")) {
    let strA = str.split("_");
    return strA[0][0] + strA[1][0] + strA[2];
  } else return str;
}
